/* global $ */

const $searchBlock = $('.js-search-block');
const $searchBtn = $('.js-search-block [type="submit"]');

const searchBlock = {
  initialize() {
    if ($searchBlock.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $searchBlock.on('keyup', '[name="query"], [name="location"]', () => {
      const $locationInput = $searchBlock.find('[name="location"]');
      const $queryInput = $searchBlock.find('[name="query"]');

      const hasSearchVal = $locationInput.val() || $queryInput.val();

      const btnText = (hasSearchVal) ? $searchBtn.data('search-text') : $searchBtn.data('all-text');

      $searchBtn.find('span').text(btnText);
    });
  },
};

export default searchBlock;
